import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import KenSelect from "../../../../../global_components/KenSelect";
import { useFormContext } from "react-hook-form";
import KenError from "../../../../../components/KenError";
import twinSharing from "../../../../../assets/icons/twinSharing.png"
import ac from "../../../../../assets/icons/ac.png"
import nonAc from "../../../../../assets/icons/nonAc.png"

const useStyles = makeStyles((theme) => ({
  box: {
    boxShadow: "none",
    borderRadius: 8,
    padding: "20px",
  },
  description2: {
    textAlign: "left",
    fontSize: "16px",
    color: "#000",
    fontWeight: 400,
  },
  accommodationBox: {
    border: "0.50px #E4E4E4 solid",
    padding: "20px",
    borderRadius: "8px",
    width: "100%",
    minHeight: "388px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  accommodationType: {
    color: "#08466F",
    fontSize: "20px",
    fontWeight: 600,
  },
  icon: {
    width: "24px",
    marginRight: 4,
  },
  amount: {
    color: "#08466F",
    fontSize: "16px",
    fontWeight: 600,
  },
  descriptionList: {
    marginTop: "20px",
  },
}));

const Accommodation = (props) => {
  const { item, handleChangePreference, disabled, preferenceOptions } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Box className={classes.accommodationBox}>
      <div>
        {disabled ? (
          <Grid item xs={12}>
            <Typography variant="p" className={classes.accommodationType}>
              {item.Name__c}
            </Typography>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Typography variant="p" className={classes.accommodationType}>
              {item.Name__c}
            </Typography>
          </Grid>
        )}
        {item?.Description__c?.length > 0 && (
          <Grid item xs={12} className={`${classes.descriptionList} scrollbar-cus`}>
            <ul>
              {item?.Description__c?.map((items, index) => {
                return (
                  <li key={index} style={{ fontSize: 16, lineHeight: "22.5px" }}>
                    {items}
                  </li>
                );
              })}
            </ul>
          </Grid>
        )}
        {item?.amenities && (
          <Grid item xs={12} style={{ marginTop: "20px" }}>
            <Typography variant="p" className={classes.description2}>
              {item.amenities}
            </Typography>
          </Grid>
        )}
      </div>
      <div>
        {item.preference !== null ? (
          <Grid item xs={12} style={{ marginTop: "20px" }}>
            {disabled ? (
              <KenSelect
                id="term-select"
                options={preferenceOptions}
                value={item.preference}
                placeholder="Select Preference"
                label="Preference"
                style={{
                  marginTop: "20px",
                  fontSize: "14px !important",
                  fontWeight: 600,
                  color: "#777777 !important",
                  textTransform: "uppercase",
                }}
                fullWidth
                className={classes.preference}
                disabled={true}
              />
            ) : (
              <KenSelect
                id="term-select"
                options={preferenceOptions}
                disabled={item?.disabled == true ? true : false}
                value={item.preference}
                placeholder="Select Preference"
                label="Preference"
                style={{
                  marginTop: "20px",
                  fontSize: "14px !important",
                  fontWeight: 600,
                  color: "#777777 !important",
                  textTransform: "uppercase",
                }}
                fullWidth
                className={classes.preference}
                {...register(`preference${item?.id + 1}`, {
                  required: "Field is required",
                  onChange: (e) => {
                    handleChangePreference(e, item?.id);
                  },
                })}
              />
            )}
            {!disabled && errors[`preference${item?.id + 1}`] && <KenError single={true} message={errors[`preference${item?.id + 1}`]?.message} />}
          </Grid>
        ) : null}
        <Grid
          item
          xs={12}
          style={{
            margin: "20px 0px 0px 0px",
            bottom: "0",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            {item?.icons &&
              item.icons.map((ico) => {
                let iconView;
                switch (ico) {
                  case "non-ac":
                    iconView = nonAc;
                    break;
                  case "ac":
                    iconView = ac;
                    break;
                  case "twin-sharing":
                    iconView = twinSharing;
                    break;
                  default:
                    iconView = null;
                }
                return <img src={iconView} className={classes.icon} />;
              })}
          </div>
          <Typography variant="p" className={classes.amount}>
            {t(`content:INR`)} &nbsp;
            {item?.currentFeeData?.Fee_Amount__c || item?.Total_Price__c}
          </Typography>
        </Grid>
      </div>
    </Box>
  );
};

export default Accommodation;
